import React from "react";
import useMediaQuery from "../../../common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { useScript } from "~/common/hooks/useScript";
import { type DetailedHTMLProps, type HTMLAttributes } from "react";

interface MountingManagerTabProps {
  mountingManagerURL: string;
  designation?: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "mounting-manager": DetailedHTMLProps<
        HTMLAttributes<HTMLElement> & {
          bearing?: string;
          language?: string;
          separator?: "point" | "comma";
        },
        HTMLElement
      >;
    }
  }
}

const MountingManagerTab: React.FC<MountingManagerTabProps> = ({ mountingManagerURL, designation }) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const isWebComponentEnabled = window.SCHA.config.isMountingManagerWebComponentEnabled;

  useScript(window.SCHA.urls.mountingMgrWebComponent);

  return (
    <div className={isDesktop ? undefined : "w-100"}>
      {isWebComponentEnabled ? (
        <mounting-manager bearing={designation} language={CURRENT_LANGUAGE} separator={"point"} />
      ) : (
        <iframe className="scha__pdp-iframe" id="mmIframe" src={mountingManagerURL} scrolling="yes" />
      )}
    </div>
  );
};

export default MountingManagerTab;
